module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPlJREFUWEfVlmsOgyAQhAUuppeRcIq2pyB6GfVi0tCUpDHqsswSUv8amI/Zp+oaf6qxfvc/APM8LyGEzVr7lHSNdMB732utlx/RlyQECfB9eX94tRgECRCFa0JkAZyEIRkCO5EFENVqQWQD3EHs+z4459aS6mABRIFpmmIZPo5ipRBsgDsIay37PvaB9PIzJ5RS6ziOAycUxQBXTnAhIICbcGSXJwyAQogAIJ0SBkCTEQJAxWP4igEkxIsBJLsh2wFJcbYDVxOxdA6wAJqO41ri2Q4gjYYaTGQS1hTPcqD5Wp5WMWPMZwvizns4BNQF6H8yB1AB6nxzgDfTo6EhjULMdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-report-form/asset/images/right-icon.png
// module id = qsMc
// module chunks = 6